import { styled } from '@linaria/react';
// intl-next Link не совместим с linaria. Не критично, при необходимости стилизовать дочерений <a> вместо Link
// eslint-disable-next-line no-restricted-imports
import Link from 'next/link';

import { hoverable } from '~theme/snippets';

const common = `
    position: relative;
	padding: 12px 18px;
	width: auto;
	background-color: var(--bg);
	border: none;
	border-radius: 12px;
	transition: color 0.15s, background-color 0.15s, backdrop-filter 0.15s,
		box-shadow 0.15s;

	&[disabled],
	&.action_loading {
		pointer-events: none;
	}

	&.action_loading {
		.loader {
		    position: absolute;
			left: 0;
			right: 0;
		    transform: scale(2.5);
		}
	}
		
	&.action_fullWidth {
	    width: 100%;
	}
`;

const text = `
	font-family: var(--font);
	color: var(--color);
	font-size: 16px;
	font-weight: 500;
	line-height: 18px;
	text-align: center;
	white-space: nowrap;
`;

export const Button = styled.button`
	${common};
	${text};
	${hoverable};
`;

export const Content = styled.div<{ hidden?: boolean }>`
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 8px;
	visibility: ${({ hidden }) => (hidden ? 'hidden' : 'visible')};
`;

export const StyledLink = styled(Link)`
	${common};
	${text};
	${hoverable};
`;
